// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"47493068","500":"68eb4b16","505":"bfe09f8a","580":"7fac84f9","964":"7ee11a9f","990":"73446cae"}[chunkId] + ".chunk.css";
};